// extracted by mini-css-extract-plugin
export default {"container":"Np-z","ratingLayout":"Op-z","ratingLabel":"Pp-z","nonInteractiveRatingLabel":"Qp-z"};